import { render, staticRenderFns } from "./TenSeconds.vue?vue&type=template&id=70febe7f&"
import script from "./TenSeconds.vue?vue&type=script&lang=js&"
export * from "./TenSeconds.vue?vue&type=script&lang=js&"
import style0 from "./TenSeconds.vue?vue&type=style&index=0&id=70febe7f&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports